import React, { useRef, useState } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@leadsnavi/ui-kit';
import { useMemoizedFn } from 'ahooks';

interface EllipseProps {
  text: string | React.ReactNode;
  tooltipText?: string | React.ReactNode;
  className?: string;
  lineClamp?: number;
}

export const Ellipse: React.FC<EllipseProps> = ({ text, tooltipText, className = '', lineClamp = 1 }) => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const ellipsisClassName = lineClamp === 1 ? 'overflow-hidden text-ellipsis whitespace-nowrap' : 'overflow-hidden';
  const ellipsisStyle =
    lineClamp > 1
      ? { display: '-webkit-box', WebkitLineClamp: lineClamp, WebkitBoxOrient: 'vertical' as const }
      : undefined;

  const onOpenChange = useMemoizedFn((open: boolean) => {
    if (open && ref.current) {
      if (lineClamp === 1) {
        // 如果是单行，判断是否超出宽度
        setIsOverflowing(ref.current.scrollWidth > ref.current.clientWidth);
      } else {
        // 如果是多行，判断是否超出高度
        setIsOverflowing(ref.current.scrollHeight > ref.current.clientHeight);
      }
    } else {
      setIsOverflowing(false);
    }
  });

  return (
    <Tooltip open={isOverflowing} onOpenChange={onOpenChange}>
      <TooltipTrigger asChild>
        <div ref={ref} className={`${ellipsisClassName} ${className}`} style={ellipsisStyle}>
          {text}
        </div>
      </TooltipTrigger>
      <TooltipContent className="max-w-[315px]  p-1   w-fit">
        <p className="break-words overflow-auto max-h-[400px] text-balance">{tooltipText ?? text}</p>
      </TooltipContent>
    </Tooltip>
  );
};
